import React from 'react';
import { Link } from '@mui/material';

export const getTeamName = (row, classes) => (
  <Link
    tabIndex="0"
    data-testid="team-name"
    href={`#/teams/${row.id}`}
    className={classes.linkStyle}
  >
    {row.data.name}
  </Link>
);
